import { SUPPORT_THREAD_REF } from '../lib/chat-thread-ref';
import { type IChatThreadState, useChatThread } from './useChatThread';
import { type ISupportSession } from './useSupportSession';

export type { SupportReach } from './useChatThread';

/**
 * The support conversation's state. One thread kind of the generic engine; kept under its old
 * name because the FAB, the Help hub and the panel all read it from `GlobalContext.supportChat`.
 */
export type ISupportChatState = IChatThreadState;

/**
 * The agent ↔ support-desk conversation, owned by the Dashboard layout.
 *
 * <p>A thin binding of {@link useChatThread} to the support thread ref. Everything that used
 * to live here — thread resolution, outbox, socket handlers, typing, reads — is the engine now,
 * so a conversation with another agent is the same code with a different ref.</p>
 *
 * <p>Mounted from <c>components/layout/index.tsx</c> beside <c>useSupportSession</c>, NOT from
 * the panel. Right-section panels unmount when inactive (only UploadResult escapes via
 * CompDisplay's d-none), so a panel-owned hook would tear down the moment an agent closes the
 * chat to go upload a result sheet — taking an in-flight send with it and leaving the FAB badge
 * with nothing to count.</p>
 */
export const useSupportChat = (isPanelOpen: boolean, session: ISupportSession): ISupportChatState =>
	useChatThread(SUPPORT_THREAD_REF, { session, isActive: isPanelOpen });
